var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
var useStyles = createUseStyles({
    backdrop: {
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        background: "rgba(4, 48, 75, 0.42)",
        transition: "opacity .5s ease-in-out",
        opacity: "0",
        "&in": {
            opacity: "1"
        },
        zIndex: 2
    },
    modal: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        zIndex: 2
    },
    modalContent: {
        background: "#FFF",
        borderRadius: 2,
        maxHeight: "100%",
        overflowY: "auto",
        padding: 16,
        transform: "translateZ(0)",
    }
});
var Modal = function (_a) {
    var isVisible = _a.isVisible, _b = _a.visibleStyles, visibleStyles = _b === void 0 ? { opacity: 1 } : _b, _c = _a.hiddenStyles, hiddenStyles = _c === void 0 ? { opacity: 0 } : _c, contentClassname = _a.contentClassname, _d = _a.transition, transition = _d === void 0 ? "opacity .5s ease-in-out" : _d, onShow = _a.onShow, onShown = _a.onShown, onHide = _a.onHide, onHidden = _a.onHidden, onBackdropClick = _a.onBackdropClick, children = _a.children;
    var classes = useStyles();
    var _e = useState(false), isTransitioning = _e[0], setIsTransitioning = _e[1];
    var _f = useState(false), isShowing = _f[0], setIsShowing = _f[1];
    var backdropRef = useCallback(function (el) {
        if (el !== null) {
            el.addEventListener("click", function (e) {
                if (e.target === el) {
                    onBackdropClick ? onBackdropClick() : undefined;
                }
            });
        }
    }, []);
    useEffect(function () {
        if (isVisible !== isShowing) {
            setIsTransitioning(true);
            if (isVisible) {
                onShow ? onShow() : undefined;
            }
            else {
                onHide ? onHide() : undefined;
            }
            setIsShowing(isVisible);
        }
    }, [isVisible]);
    if (!isVisible && !isShowing && !isTransitioning) {
        return null;
    }
    var modalContainer = document.getElementById("modalContainer");
    if (modalContainer === null) {
        return null;
    }
    var styles;
    if (isShowing) {
        styles = __assign({ transition: transition }, visibleStyles);
    }
    else {
        styles = __assign({ transition: transition }, hiddenStyles);
    }
    return ReactDOM.createPortal(React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx(classes.backdrop, isShowing && "in") }),
        React.createElement("div", { className: classes.modal, style: styles, ref: backdropRef, onTransitionEnd: function () {
                if (isVisible) {
                    onShown ? onShown() : undefined;
                }
                else {
                    onHidden ? onHidden() : undefined;
                }
                setIsTransitioning(false);
            } },
            React.createElement("div", { className: clsx(classes.modalContent, contentClassname) }, children))), modalContainer);
};
export default Modal;
//# sourceMappingURL=Modal.js.map